var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_c('p',[_vm._v("—— 233网校 · 专注在线职业教育学习服务 ——")]),_c('p',[_vm._v("版权所有©2005-2020 长沙二三三网络科技有限公司(233.com) All Rights Reserved 湘ICP备17011479号-1")])])
}]

export { render, staticRenderFns }